import { render, staticRenderFns } from "./ModalQuotationConfirm.vue?vue&type=template&id=077afd97&scoped=true&"
import script from "./ModalQuotationConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalQuotationConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077afd97",
  null
  
)

export default component.exports